var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
export class MenubarProgress {
    parent;
    isButtonHovering = false;
    isProgressMenuOpen = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    get topic() {
        return this.app.solidTopic;
    }
    enableNextRepeatStep() {
        const { passed, passed2, passed3, correctafterwrong } = this.app.topic.topicFilter.passStateObject;
        const filter = this.app.funnel.funnelMixed.mixedFilter;
        if (passed.isFiltered && filter.hasNoMoreQuestions) {
            correctafterwrong.enableForUser();
            passed.enableForUser();
        }
        if (passed2.isFiltered && filter.hasNoMoreQuestions) {
            passed2.enableForUser();
        }
        if (passed3.isFiltered && filter.hasNoMoreQuestions) {
            passed3.enableForUser();
        }
    }
    closeProgressMenu() {
        this.isProgressMenuOpen = false;
    }
}
__decorate([
    observable
], MenubarProgress.prototype, "isButtonHovering", void 0);
__decorate([
    observable
], MenubarProgress.prototype, "isProgressMenuOpen", void 0);
__decorate([
    action.bound
], MenubarProgress.prototype, "enableNextRepeatStep", null);
__decorate([
    action.bound
], MenubarProgress.prototype, "closeProgressMenu", null);
